// pages/partnershipsThankYou/PartnershipsThankYou.jsx
import React from "react";
import "./partnershipsThankYou.css";
import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <h1>Thank You!</h1>
        <p>Your message has been received. We’ll be in touch soon.</p>
        <Link
          to="/"
          style={{
            display: "inline-block",
            marginTop: "35px",
          }}
        >
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}
